export default {seo:{title:'Profils associés',description:null},title:'Associer un profil Senskle'};